import React, { Component } from "react";
import ReadDetail from 'nbugs-pc-read';
import { parse } from "qs";
import { ENV } from "../../../../../services/utils";
import Container from "../../../../../components/Container";

/**
 * 阅读详情
 */
class Index extends Component {

  render() {
    const {id} = parse(window.location.search.split("?")[1]) || {};
    return (
      <Container breStates>
        <ReadDetail
          className='nbugs-component-read'
          msgId={id}
          btnExportText='导出明细'
          APIEnv={ENV}
        />
      </Container>
    );
  }
}

export default Index;
